import Icon from '@mdi/react'
import { mdiChevronLeft } from '@mdi/js'

import theme from 'theme_'
import { StyledMobileBackBtn } from './styles'

interface MobileBackBtnProps {
  handleClick: () => void
  text: string
}

function MobileBackBtn(props: MobileBackBtnProps) {
  return (
    <StyledMobileBackBtn onClick={props.handleClick}>
      <Icon path={mdiChevronLeft} size={1} color={theme.colors.horizonOrange} />
      {props.text}
    </StyledMobileBackBtn>
  )
}

export default MobileBackBtn
